import urlUtils from './urlUtils'

export default {
    getMediaUrl(serviceTopology, mediaPath, outputFolder = 'resources') {
        const baseUrl = serviceTopology?.scriptsDomainUrl || 'https://static.parastorage.com/'
        return urlUtils.joinURL(baseUrl, 'services', 'santa-resources', outputFolder, 'viewer', mediaPath)
    }
}
